export const SALES_SUPPORT = {
  FETCH_CONTACTS: (metadataid) => `/messagecontact/metadataid/${metadataid}/getcontacts`,
  FETCH_MESSAGES: (metadataid, phone) => `/message/metadataid/${metadataid}/phone/${phone}`,
  SEND_MESSAGE: (metadataid) => `/message/metadataid/${metadataid}/sendMessage`,
  SEND_REACTION: (metadataid) => `/message/metadataid/${metadataid}/react`,
  RESET_UNREAD_COUNTS: (metadataid, phone) =>
    `/messagecontact/metadataid/${metadataid}/phone/${phone}/resetunreadcount`,
};

export const TELEGRAM = {
  FETCH_BOT_CONFIGS: () => `/botconfig`,
  ADD_BOT_CONFIG: () => `/botconfig`,
  DELETE_BOT_CONFIG: (botId) => `/botconfig/${botId}`,
  FETCH_CONTACTS: (botConfigId) => `/messagecontact/botconfigid/${botConfigId}/getcontacts`,
  FETCH_MESSAGES: (botConfigId, chatId) => `/message/botconfigid/${botConfigId}/chatid/${chatId}`,
  SEND_MESSAGE: (botConfigId, chatId) =>
    `/message/botconfigid/${botConfigId}/chatid/${chatId}/sendMessage`,
  RESET_UNREAD_COUNTS: (botconfigid, chatid) =>
    `/messagecontact/botconfigid/${botconfigid}/chatid/${chatid}/resetunreadcount`,
};
